var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAouModalSuccessImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1429_961",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 128,
    height: 128
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 127.131,
    height: 127.131,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1429_961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.1495 73.1007L44.7607 61.7119C43.7895 60.7408 42.5535 60.2552 41.0527 60.2552C39.5518 60.2552 38.3158 60.7408 37.3447 61.7119C36.3736 62.6831 35.888 63.9191 35.888 65.4199C35.888 66.9208 36.3736 68.1568 37.3447 69.1279L52.4415 84.2247C53.5009 85.2841 54.7369 85.8138 56.1495 85.8138C57.562 85.8138 58.798 85.2841 59.8575 84.2247L89.7862 54.296C90.7573 53.3248 91.2429 52.0888 91.2429 50.588C91.2429 49.0871 90.7573 47.8511 89.7862 46.88C88.815 45.9089 87.579 45.4233 86.0782 45.4233C84.5773 45.4233 83.3413 45.9089 82.3702 46.88L56.1495 73.1007ZM63.5654 116.537C56.2378 116.537 49.3515 115.147 42.9067 112.366C36.4618 109.585 30.8557 105.81 26.0883 101.043C21.3209 96.2756 17.5467 90.6695 14.7657 84.2247C11.9847 77.7799 10.5942 70.8936 10.5942 63.5659C10.5942 56.2382 11.9847 49.352 14.7657 42.9072C17.5467 36.4623 21.3209 30.8562 26.0883 26.0888C30.8557 21.3214 36.4618 17.5472 42.9067 14.7662C49.3515 11.9852 56.2378 10.5947 63.5654 10.5947C70.8931 10.5947 77.7794 11.9852 84.2242 14.7662C90.669 17.5472 96.2752 21.3214 101.043 26.0888C105.81 30.8562 109.584 36.4623 112.365 42.9072C115.146 49.352 116.537 56.2382 116.537 63.5659C116.537 70.8936 115.146 77.7799 112.365 84.2247C109.584 90.6695 105.81 96.2756 101.043 101.043C96.2752 105.81 90.669 109.585 84.2242 112.366C77.7794 115.147 70.8931 116.537 63.5654 116.537Z",
    fill: "url(#paint0_linear_1429_961)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1429_961",
    x1: 43.0561,
    y1: 43.1055,
    x2: 87.5961,
    y2: 193.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58AF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854515,
    stopColor: "#91C153"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAouModalSuccessImg);
export default __webpack_public_path__ + "static/media/aou-modal-success-img.8033ffcecfbd6fc98aee60d02f5d1c12.svg";
export { ForwardRef as ReactComponent };